<template>
  <!--页面主体-->
  <div class="g-container">
    <div class="m-container m-width">
      <!--面包屑-->

      <!--申请匠心记-->
      <div class="apply-orig-main">
        <div class="apply-orig-hd">
          <ul>
            <!--选中 +active-->
            <li :class="{ active: setp == 1 }">
              <!--                            <h4>第一步</h4>-->
              <p>现场情况编写</p>
              <i></i>
            </li>
            <li :class="{ active: setp == 2 }">
              <!--                            <h4>第二步</h4>-->
              <p>客户告知函编写</p>
              <i></i>
            </li>
            <li :class="{ active: setp == 3 }">
              <!--                            <h4>第三步</h4>-->
              <p>客户确认下单</p>
              <i></i>
            </li>
          </ul>
        </div>

        <div class="apply-orig-content">
          <!--填写项目信息-->
          <div class="apply-orig-box" v-if="setp == 1">
            <!--                        <h1 class="a-orig-tit">创建的我匠心记</h1>-->
            <div>
              <!--项目概况-->
              <div class="a-orig-column">
                <div class="a-column-tit">
                  <div class="a-tit">现场基础情况异常</div>
                </div>

                <div class="active-h5" v-show="technologicalProcess == 1 || technologicalProcess ==3">
                  <p>基层表现情况 ------> </p>
                  <p> 沥青基础表面是否返油 </p>
                </div>

                <div class="apply-form" >
                  <div
                    class="apply-form-row"
                    v-for="(item, index) in form1"
                    :key="index"
                    v-show="technologicalProcess ==2 ||technologicalProcess ==0"
                  >
                    <el-select
                      v-model="item.title"
                      placeholder="请选择异常类型"
                      @change="getDeviantList(1, index)"
                    >
                      <el-option
                        v-for="item in basicSituation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <!--                                        <span class="unit-vere">(*必填)</span>-->
                    <el-select
                      v-model="item.parentId"
                      placeholder="请选择异常情况"
                      @focus="openDeviaDia(index)"
                      multiple
                      ref="deviaSelect"
                      :popper-append-to-body="false"
                      class="deviaSelect"
                    >
                      <el-option
                        v-for="item in item.sceneDeviantList"
                        :key="item.Content"
                        :label="item.Content"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                    <deviantDialog
                      ref="sceneDia"
                      :deviantList="item.sceneDeviantList"
                      @addTypeSelect="addTypeSelect(arguments, index)"
                    ></deviantDialog>
                  </div>

                  <div class="a-column-tit">
                    <div class="a-tit">水性专用施工机器</div>
                  </div>
                  <div class="active-h5" v-show="technologicalProcess == 1 || technologicalProcess ==3">
                    <p>水性专用搅拌机</p>
                  </div>
                  <div class="apply-form-row" v-show="technologicalProcess ==2 || technologicalProcess ==0">
                    <el-select
                      v-model="form1[0].parentIds"
                      placeholder="请选择异常类型"
                      multiple
                    >
                      <el-option
                        v-for="item in waterPropertyList"
                        :key="item.Content"
                        :label="item.Content"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <span class="unit-vere">(*必填)</span>-->
                  </div>
                </div>
              </div>
              <div class="apply-form-row-list" v-if="technologicalProcess">
                <div class="apply-form-row-list-top">
                  <div class="apply-form-row-list-left">
                    <span class="apply-form-row-list-ico">
                      <img
                        :src="userInfo ? userInfo.HeadImage : ''"
                        alt=""
                        style="width: 35px; height: 35px; border-radius: 20px"
                      />
                    </span>项目负责人
                    <span>{{userInfo ? userInfo.NickName : ""}}</span>
                  </div>
                  <div
                    class="apply-form-row-list-right-newJxjApply"
                    v-show="technologicalProcess == 3"
                  >
                    <span class="apply-form-row-list-ico">
                      <img
                        src="../../../../html/pages/originality/newJxjApply/images/对号2.png"
                        alt=""
                      />
                    </span>
                    <span class="apply-form-row-list-text-newJxjApply">已审核</span>
                  </div>
                  <div
                    class="apply-form-row-list-right-newJxjApply"
                    v-show="technologicalProcess == 1"
                  >
                    <span class="apply-form-row-list-ico">
                      <img
                        src="../../../../html/pages/originality/newJxjApply/images/ico-time.png"
                        alt=""
                      />
                    </span>
                    <span class="apply-form-row-list-text-newJxjApply">待审核</span>
                  </div>
                  <div
                    class="apply-form-row-list-right-newJxjApply"
                    v-show="technologicalProcess == 2"
                  >
                    <span class="apply-form-row-list-ico">
                      <img
                        src="../../../../html/pages/originality/newJxjApply/images/tuihui.png"
                        alt=""
                      />
                    </span>
                    <span class="apply-form-row-list-text-newJxjApply">已退回</span>
                  </div>
                </div>

                <div class="esc" v-show="technologicalProcess == 2 && ConfirmInfo.length >=0 ">
                  <div class="esc-ico">
                    <div class="esc-ico-ico" @click="dialogFormVisible = true">
                      <img
                        src="../../../../html/pages/originality/newJxjApply/images/ico-Inform.png"
                        alt=""
                        style="width: 20px; height: 14px"
                      />
                      <span>退回信息</span>
                    </div>
                  </div>
                  <div class="esc-text">
                    <ul class="esc-text-div">
                        <li v-for="item in ConfirmInfo">
                          <span>{{ item.Reason }}</span>
                          <span>{{ item.CreatedTime }}</span>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="cm-form-btn">
                <div
                  v-show="technologicalProcess == 3 || technologicalProcess == 2"
                  class="cu-form-btn-cz"
                  @click="goToSmallProgram"
                >
                  转发至客户
                </div>
                <div
                  class="cu-form-btn-cz"
                  @click="dialogFormVisible = true"
                  style="background: #b8b8b8"
                  v-show="technologicalProcess == 1"
                >
                  退回
                </div>
                <div
                  class="cu-form-btn-cz"
                  @click="reset"
                  style="background: #b8b8b8"
                  v-show="!technologicalProcess"
                >
                  重置
                </div>
                <el-button
                  class="form-btn-qd"
                  @click="submitStep1"
                  v-show="!technologicalProcess || technologicalProcess == 2"
                >
                  提交审核
                </el-button>
                <el-button
                  class="form-btn-qd"
                  @click="submitExamine(3)"
                  v-show="technologicalProcess == 1"
                >
                  通过审核
                </el-button>
              </div>
            </div>
          </div>
          <!--                    二维码-->
          <el-dialog :visible.sync="dialogErweimaVisible" center id="er">
            <img
              :src="erweimaImg"
              alt=""
              style="width: 306px; height: 305px"
            />
            <div slot="footer" class="dialog-footer">
              扫一扫后在小程序内打开，转发给客户
            </div>
          </el-dialog>

          <!--                    描述信息-->
          <el-dialog
            :visible.sync="dialogFormVisible"
            center
            id="describe-dialog"
          >
            <el-input
              class="inputTextarea"
              type="textarea"
              :rows="11"
              placeholder="请简述退回原因..."
              v-model="textarea"
            >
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button class="btn-qx" @click="dialogFormVisible = false"
                >取 消</el-button>
              <el-button class="btn-qd" @click="submitClick">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import "../../../../html/components/crumbs/crumbs.scss";
import "../../../../html/pages/originality/newJxjApply/apply.scss";
import "../../../../html/pages/originality/modifyProject/modifyProject.scss";
import deviantDialog from "./components/deviantDialog.vue";
import {
  addInfo,
  getDeviantList,
  GetJxjProUsers,
  GetJxjProUserTypes,
  getJxjTags,
  getParentProInfos,
  jxjAddProjectLog,
  uploadImage,
  subConfirm,
  getInfoById,
  getCode,
} from "../../../../api";
import { mapState } from "vuex";

export default {
  name: "newJxjApply",
  components: { deviantDialog },
  data() {
    return {
      userInfo: null,
      Id: null,
      textarea: "",
      newTime: "",
      erweimaImg:'',
      dialogErweimaVisible: false, //二维码
      dialogFormVisible: false, //描述信息
      tags: [],
      setp: 1,
      persons: [],
      setp1Dir: false,
      parentIds: [],
      basicSituation: [
        {
          label: "基层表现情况",
          value: 1,
        },
        {
          label: "基层排水情况",
          value: 2,
        },
        {
          label: "排水沟与排水沟盖板的情况",
          value: 3,
        },
      ],
      form1: [
        {
          parentId: [],
          parentIds: [],
          title: "", //项目名称
          // createdTime: '',//创建时间
          desc: "", //项目简介
          picPath: "", //图片
          tagIds: [], //标签
          productName: "", //产品名称
          productPart: "", //产品组成
          productTrait: "", //产品特点
          quality: "", //工程质量
          cycle: "", //工程周期
          scale: "", //工程规模
          proUsers: [],
          sceneDeviantList: [], //现场问题类型
          url:'http:192.........',

        },
      ],
      ConfirmInfo: [],
      rules: {
        title: [{ required: true, message: "请填写项目名称!" }],
        parentId: [{ required: true, message: "请选择项目类型!" }],
        desc: [{ required: true, message: "请填写项目简介!" }],
        picPath: [{ required: true, message: "请添加图片!" }],
        tagIds: [{ required: true, message: "请选择标签!" }],
        productName: [{ required: true, message: "请填写产品名称!" }],
        productPart: [{ required: true, message: "请填写产品组成!" }],
        productTrait: [{ required: true, message: "请填写产品特点!" }],
        quality: [{ required: true, message: "请填写工程质量!" }],
        cycle: [{ required: true, message: "请填写工程周期!" }],
        scale: [{ required: true, message: "请填写工程规模!" }],
      },
      waterPropertyList: [],
      subBtnStr: "提交审核",
      subBtn: false,
      tuihui: false,
      technologicalProcess: 0, //当前流程走向
      DeviantInfo:{},

    };
  },
  computed: {},
  methods: {
    //获取异常列表
    getDeviantList(type, index) {
      getDeviantList({ type: type }).then((res) => {
        const { Data } = res;
        console.log(Data)
        if (type == 1) {
          var sceneDeviantList = Data.DeviantList.filter((item) =>
              item.SiteTypeId == this.form1[index].title
            );
          this.$set(this.form1[index], "sceneDeviantList", sceneDeviantList);
          this.$refs["sceneDia"][index].checkList = [];
          return;
        }
        this.waterPropertyList = Data.DeviantList;
      });
    },

    //打开异常列表
    openDeviaDia(index) {
      this.$refs["sceneDia"][index].dialogTableVisible = true;
    },
    //添加异常选择项
    addTypeSelect(checkList, index) {
      this.$set(this.form1[index], "parentId", checkList[0]);
      this.$refs["deviaSelect"][index].blur();
      if (!this.form1[index].title || this.form1[index].title == "") {
        return;
      }
      if (
        this.$refs["sceneDia"].length >= 3 ||
        this.$refs["sceneDia"].length != index + 1
      ) {
        return;
      }
      this.form1.push({});
    },
    async getJxjTags() {
      let res = await getJxjTags();
      if (res.Type == "Success") {
        res.Data.forEach((item) => {
          item.active = false;
        });
        this.tags = res.Data;
      } else {
        this.$layer.alert(res.Content);
      }
    },
    async getParentProInfos() {
      let res = await getParentProInfos();
      if (res.Type == "Success") {
        this.parentIds = res.Data;
      }
    },
    chooseTags(i) {
      this.tags[i].active = !this.tags[i].active;
      this.form1.tagIds = [];
      this.tags.forEach((item) => {
        if (item.active) {
          this.form1.tagIds.push(item.id);
        }
      });
    },
    //添加现场图片
    async uploadImg() {
      let file = this.$refs.imgFileInput.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      let that = this;
      reader.onload = async function (e) {
        let res = await uploadImage({
          file: file,
        });
        if (res.Type == "Success") {
          that.form1.picPath = res.Data;
        }
      };
    },
    //获取告知函状态
    getById() {
      var Id=this.$route.query.Id
      console.log(Id,'aaaaaaaaaaaaa')
        getInfoById({
          Id: Id,
        }).then((res) => {
          if (res.Type == 'Success'){
            console.log(res.data.Type,'mmmmmmmmmmmmmmmmmmmmmmmm')
            this.technologicalProcess = res.Data.IsConfirm;
            this.textarea =  res.Data.ConfirmInfo.Reason
            this.newTime = res.Data.CreatedTime
            this.ConfirmInfo = res.Data.ConfirmInfo
            this.DeviantInfo = res.Data.DeviantInfo

          }else {
            this.$message({
              message: res.data.Content,
              type: res.data.Type,
            });
          }


        });

    },


    //提交信息
    submitStep1() {
      let DeviantInfo = [];
      const pageMissage = {};
      this.$refs["sceneDia"].forEach((item) => {
        DeviantInfo = DeviantInfo.concat(item.checkList);
      });
      //
      // if (localStorage.getItem("createAdd")) {
      //   const { proUsers, title, mobile, tagIds, nameItems ,nameListIndex } = JSON.parse(
      //     localStorage.getItem("createAdd")
      //   );
      //   pageMissage.ProName = title;
      //   pageMissage.YzkTagIds = "," + tagIds + ",";
      //   pageMissage.ProUserIds = "," + nameListIndex[0].Id + ",",
      //   pageMissage.CustomPhone = mobile;

      // }

        addInfo({
          ...this.$route.query, //文件上传页参数
          ...pageMissage, //
          DeviantInfo: "," + DeviantInfo.concat(this.form1[0].parentIds).toString() + ",",
          Id: this.$route.query.Id,
        }).then((res) => {
          console.log(res,'111111111111111')
          this.Id = this.$route.query.Id;
          this.submitExamine(1);
          // localStorage.setItem("Id", res.Data);

        });
        // if(this.technologicalProcess == 2){
        //   this.submitExamine(1);
        // }


    },
    //提交审核
    submitExamine(type) {
      // const { nameListIndex, proUsers } = JSON.parse(
      //   localStorage.getItem("createAdd")
      // );
      subConfirm({
        Id: this.$route.query.Id,
        isConfirm: type,
        Reason: this.textarea,
        // ProUserIds: "," + nameListIndex[0].Id + ",",
      }).then((res) => {
        if (res.Type == "Error") {
          this.$message.error(res.Content);
          return;
        }
        this.technologicalProcess = type;
        this.$message.success(res.Content);
      });
    },
    //重置
    reset() {
      this.form1 = [{ ...this.form1[0] }];
      this.form1[0].parentId = []
      this.form1[0].parentIds = []
      this.form1[0].title = ''
      this.form1[0].sceneDeviantList = []
    },
    async submitStep2() {
      let dir = true;
      for (let i = 0; i < this.persons.length; i++) {
        if (
          this.persons[i].arr.length == 0 &&
          this.persons[i].typeName != "协理"
        ) {
          dir = false;
          this.$layer.alert("请添加" + this.persons[i].typeName);
          break;
        }
      }

      if (!dir) {
        return false;
      }
      this.form1.proUsers = [];
      this.persons.forEach((item) => {
        item.arr.forEach((person) => {
          this.form1.proUsers.push({
            id: person.id,
            type: item.id,
          });
        });
      });

      let res = await jxjAddProjectLog(this.form1);

      if (res.Type == "Success") {
        this.setp = 3;
      }
    },
    async getUserByPhone(phone, callback) {
      let res = await GetJxjProUsers({
        phone: phone,
      });
      if (callback) {
        callback(res);
      }
    },
    getonlineUser(item) {
      if (item.searchPhone == "") {
        item.searchName = "这边显示昵称";
        item.proAddUser = null;
        return;
      }
      if (!/^1[34578]\d{9}$/.test(item.searchPhone)) {
        item.searchName = "号码不正确";
        item.proAddUser = null;
        return;
      }
      this.getUserByPhone(item.searchPhone, (res) => {
        if (res.Type == "Success") {
          res.Data.isDir = true;
          item.proAddUser = res.Data;
          // item.proAddUser.type = item.type;

          item.searchName = res.Data.nickName;
        } else {
          item.proAddUser = null;
          item.searchName = "查无此人";
        }
      });
    },
    addPerson(item) {
      if (item.proAddUser == null) {
        return false;
      }
      item.arr.push(item.proAddUser);
      item.proAddUser = null;
      item.searchPhone = "";
      item.searchName = "这边显示昵称";
    },
    delPerson(item, i) {
      item.arr.splice(i, 1);
    },
    async GetJxjProUserTypes() {
      let res = await GetJxjProUserTypes();
      if (res.Type == "Success") {
        res.Data.forEach((item) => {
          item.arr = [];
          item.proAddUser = null;
          item.searchPhone = "";
          item.searchName = "这边显示昵称";
        });
        res.Data.forEach((item) => {
          if (item.id <= 7) {
            this.persons.push(item);
          }
        });
        // this.persons = res.Data;
        this.getUserByPhone(this.userInfo.phone, (res) => {
          res.Data.isDir = false;
          this.persons[0].arr.push(res.Data);
        });
      }
    },
    submitClick() {

      this.submitExamine(2);
      this.dialogFormVisible = false;

    },
    //获取小程序码
    async goToSmallProgram() {
      this.dialogErweimaVisible = true;
      var data = {
        page: 'pages/jxj/index',
        scene: 'id=' + this.$route.query.Id
      }
      let res = await getCode(data);
        console.log(res,'get二维码')
        if (res.Type == 'Success') {
          this.erweimaImg = res.Data
        }

    },
  },
  created() {
  },
  mounted() {

    this.getById()
    this.getDeviantList(2);
    console.log(JSON.parse(localStorage.getItem("createAdd")));
    if (localStorage.getItem("createAdd"))
      this.userInfo = JSON.parse(localStorage.getItem("createAdd")
      ).nameListIndex[0];

    var toduId= this.$route.query.Id
    console.log(toduId,'111111')
  },
};
</script>

<style scoped>
#er .el-dialog {
  width: 450px;
  height: 456px;
  background: #ffffff;
  border-radius: 20px;
}

#er .el-dialog__body {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
  margin-top: 50px;
}

#er .el-dialog__body img {
  display: block;
  margin: 0;
  padding: 0;
}

/deep/ .deviaSelect .el-select-dropdown {
  display: none !important;
}

/deep/ .deviaSelect .el-tag__close {
  display: none !important;
}
.form-btn-qd {
  width: 140px;
  background: red;
  color: #ffffff;
  border-radius: 20px;
}
.active-h5 {
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.active-h5 p {
  font-size: 16px;
  background-color: #eee;
}
  .apply-form{
    margin-top: 50px;
  }
  .esc-text-div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
</style>
